import React, { Component } from 'react';
import { observer, Provider, inject } from 'mobx-react';
import { autorun } from 'mobx';
import { CeilingStore } from './ceiling.store';
import { CeilingComponent } from './ceiling.component';
import CeilingForm from './ceiling.form';

@inject('livingRoomStore', 'appStore', 'routerStore')
@observer
export class CeilingProvider extends Component {
    store;
    currentRoomNum;
    disabledEraZoneAutorun = false;
    disabledRoomAreaAutorun = false;
    disabledHydrateAutorun = false;

    constructor(props) {
        super(props);
        const { livingRoomStore, appStore, routerStore, match } = props,
            { history } = routerStore;

        appStore.setURLProps(match);
        appStore.clearError();

        this.currentRoomNum = parseInt(match.params.num, 10);
        livingRoomStore.currentRoomNum = this.currentRoomNum;

        this.store = new CeilingStore({
            appStore,
            currentRoomNum: this.currentRoomNum
        });

        this.form = new CeilingForm({
            store: this.store,
            appStore: appStore,
            currentRoomNum: this.currentRoomNum
        });

        this.disposeForm = autorun(() => {
            if (!this.disabledEraZoneAutorun) {
                this.setEraAndZone(appStore);
            }

            if (!this.disabledRoomAreaAutorun) {
                this.setRoomAreaField(appStore);
            }

            if (!appStore.loading && !this.disabledHydrateAutorun) {
                this.hydrateForm(appStore);
            }

            if (this.store.goNext) {
                this.store.goNext = false;

                const dest = this.getDest(appStore, livingRoomStore);
                history.push({ pathname: dest, state: { transition: 'forward' } });
            }
        });
    }

    getDest(appStore, livingRoomStore) {
        if (this.currentRoomNum < livingRoomStore.numRooms) {
            return `/livingroom/${this.currentRoomNum + 1}/walls`;
        }

        return appStore.submissionID ? `/result/${appStore.submissionID}` : '/result';
    }

    componentWillUnmount() {
        this.disposeForm();
    }

    /**
     * Update era and zone on all rvalue fields
     * @param appStore
     */
    setEraAndZone(appStore) {
        if (!this.disabledEraZoneAutorun && appStore.era && appStore.zone) {
            this.form.era = appStore.era;
            this.form.zone = appStore.zone;
            this.form.retrofitted2009 = appStore.retrofitted2009 === 'yes';
            this.form.standards2009Compliant = appStore.standards2009Compliant;
            this.form.rValueEra = appStore.rValueEra;

            this.form.setExtraProps({
                era: appStore.era,
                zone: appStore.zone,
                retrofitted2009: appStore.retrofitted2009 === 'yes',
                standards2009Compliant: appStore.standards2009Compliant,
                rValueEra: appStore.rValueEra
            });

            this.disabledEraZoneAutorun = true;
        }
    }

    /**
     * Set the value of the floor area (read-only)
     * @param appStore
     */
    setRoomAreaField(appStore) {
        try {
            let floorArea;

            if (this.currentRoomNum === 1) {
                floorArea = appStore.userData.floorarea.floorarea.area;
            } else {
                floorArea =
                    appStore.userData.floorarea[`room${this.currentRoomNum}`][`room${this.currentRoomNum}area`];
            }

            if (floorArea && typeof floorArea !== typeof undefined) {
                this.form.$('ceilingdetails.floorarea').set('value', floorArea);
                this.disabledRoomAreaAutorun = true;
            } else {
                // redirect to floorarea?
            }
        } catch (e) {}
    }

    /**
     * hydrate ceiling form
     * @param appStore
     */
    hydrateForm(appStore) {
        const roomKey = `room${this.currentRoomNum}`;
        let fieldData = null;

        if (
            !appStore.userData ||
            appStore.userData.rooms === undefined ||
            appStore.userData.rooms[roomKey] === undefined ||
            appStore.userData.rooms[roomKey].ceiling === undefined ||
            appStore.userData.rooms[roomKey].ceiling === null
        ) {
            return;
        }

        fieldData = appStore.userData.rooms[roomKey].ceiling.skylightdetails;

        if (fieldData) {
            this.populateSkylights(fieldData);
        }

        appStore.hydrateFormFields(
            appStore.userData.rooms[roomKey].ceiling,
            false,
            this.form
        );
        this.disabledHydrateAutorun = true;
    }

    populateSkylights(fieldData) {
        // add windows and doors
        let skylights = 0;

        Object.keys(fieldData).forEach(childName => {
            if (/skylights/gi.test(childName) === true) {
                skylights = Object.keys(fieldData[childName]).length;
            }
        });

        if (skylights > 0) {
            for (let i = 1; i <= skylights; i += 1) {
                this.form.addSkylight(i, 'skylightdetails');
            }
        }
    }

    render() {
        return (
            <Provider form={this.form} store={this.store}>
                <CeilingComponent key='ceiling' />
            </Provider>
        );
    }
}
